/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */


import React from 'react';
import { DataShareSettings } from '@features/data-share/DataShareSettings';
import { useParams } from 'react-router-dom';

export const DataShareRoute = () => {

  const { shareId, initiativeId } = useParams<{ initiativeId: string, shareId?: string }>()

  return <DataShareSettings initiativeId={initiativeId} shareId={shareId}/>
}
